import ParcelexApi from '@/services/parcelex';

export default {
  async preApprove({ apiKey, env, cpf, phone, email, zipCode, trackId, price }) {
    return ParcelexApi.post('/public/preApprove', {
      apiKey,
      env,
      cpf,
      phone,
      email,
      zipCode,
      source: 'pdp',
      trackId,
      price,
    });
  },
  async preview({
    apiKey,
    env,
    totalProductPrice,
    shipping,
    cpf,
    email,
    phone,
    zipCode,
    trackId,
  }) {
    return ParcelexApi.post('/public/preview', {
      apiKey,
      env,
      totalProductPrice,
      shipping,
      cpf,
      email,
      phone,
      zipCode,
      trackId,
    });
  },
};
